import { SectionHeading } from "../components/common/SectionHeading";
import { experience } from "../data/experience";
import { Expertise } from "./Expertise";
export function Experience() {
  return (
    <section id="experience" className="experience-section shell">
      <SectionHeading
        eyebrow="03 / PROFESSIONAL EXPERIENCE"
        title={
          <>
            Where I’ve
            <br />
            <em>made my mark.</em>
          </>
        }
        description={
          <>
            Working with teams to turn product requirements
            <br />
            into dependable, usable applications.
          </>
        }
      />
      <div className="experience-list">
        {experience.map((job, i) => (
          <article className="experience-row" key={job.company} data-reveal>
            <span className="experience-number">0{i + 1}</span>
            <div>
              <h3>{job.company}</h3>
              <p className="job-role">{job.role}</p>
            </div>
            <p className="job-description">{job.description}</p>
            <span className="job-dates">{job.dates}</span>
          </article>
        ))}
      </div>
      <Expertise />
    </section>
  );
}
